import { maxValue, minValue, number, pipe, type InferOutput } from 'valibot'

export const WeaponStrengthSchema = pipe(number(), minValue(0), maxValue(20))

export type WeaponStrength = InferOutput<typeof WeaponStrengthSchema>
